import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for legacy `/libraries/plan/*` (v1).
 *
 * Distinct from `/libraries/plan-packages/*` (v2) paths in `planPackagesPaths.ts`.
 * Optional edit params use a plain path string (same pattern as `projectsPaths` optional routes).
 */
export const planListRoute = defineRoute("/libraries/plan");
export const planDetailsRoute = defineRoute("/libraries/plan/:planPackageId/:planPackageVersionId");
export const planDetailsOverviewRoute = defineRoute("/libraries/plan/:planPackageId/:planPackageVersionId/overview");
export const planDetailsOptionDataRoute = defineRoute(
  "/libraries/plan/:planPackageId/:planPackageVersionId/option-data",
);
export const planDetailsActivityRoute = defineRoute("/libraries/plan/:planPackageId/:planPackageVersionId/activity");
export const planDetailsDocumentsRoute = defineRoute("/libraries/plan/:planPackageId/:planPackageVersionId/documents");
/** Optional `:planPackageId?/:planPackageVersionId?` — not a `defineRoute` (optional params). */
export const planEditPath = "/libraries/plan/edit/:planPackageId?/:planPackageVersionId?";
export const planTakeoffsRoute = defineRoute("/libraries/plan/:planPackageId/:planPackageVersionId/takeoffs");
export const planIncomingSlotReviewRoute = defineRoute(
  "/libraries/plan/:planPackageId/:planPackageVersionId/incoming-slot-review",
);
